const currencyFormatter = (amount: number, useCurrency: boolean = true) => {
  if ((typeof amount !== 'number') || !Number.isSafeInteger(amount)) {
    return ''
  }
 
  try {
    // Intl.NumberFormat is not stable in all browsers
    const options = useCurrency ? {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
      maximumFractionDigits: 0,
    } : {}
    const numberFormat = new Intl.NumberFormat('nl-NL', options)
    return `${numberFormat.format(amount)},-`
  } catch (err) {
    const currencySymbol = useCurrency ? '\u20AC ' : '' // u20AC: euro, 
    const fixedAmount = amount.toFixed()
    return `${currencySymbol}${fixedAmount},-`
  }
}
 
 export default currencyFormatter